import React, { useState } from 'react'
import { API, graphqlOperation } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { Auth } from 'aws-amplify'
import { StorageService } from '../../../lib/StorageService'
import Button from 'antd/lib/button'
import history from '../../../History'

const styles = {
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}

const op = `mutation CreateTenantAcknowledgements($input: tenantAcknowledgementsInput){
    createTenantAcknowledgements(input: $input) {
            pk
            sk
            d1
            building
            tenant
            acknowledgements {
                active
                declined
                timestamp
                acknowledgedBy {
                    firstName
                    lastName
                    email
                }
            }
    }
}`

const AcknowledgeForm = ({ callback, onRefresh }) => {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const tenant = useSelector((state) => state.app.tenant)
    const building = useSelector((state) => state.app.building)
    const user = useSelector((state) => state.app.user)

    const mutateAcknowledgement = async (declined) => {
        if (isSubmitting) return // Prevent multiple submissions

        setIsSubmitting(true)

        let data = {
            pk: tenant.pk,
            sk: 'TENANT_ACKNOWLEDGEMENTS',
            d1: tenant.d1,
            tenant: tenant.name,
            building: building.name,
            acknowledgements: [
                {
                    acknowledgedBy: {
                        email: user.email,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        d2: user.d2,
                        pk: user.pk,
                    },
                    active: declined ? false : true,
                    timestamp: Date.now(),
                },
            ],
        }

        if (declined) {
            data.acknowledgements[0].declined = true
        }

        let response
        try {
            response = await API.graphql(graphqlOperation(op, { input: data }))

            // If acceptance was successful and not declined, refresh the data
            if (!declined && response.data && response.data.createTenantAcknowledgements) {
                // Call callback immediately to close acknowledgement modal
                // This will trigger onAcknowledged() in TenantConfigurator which handles
                // showing the population modal or navigating to admin dashboard
                callback(false)

                // FIXED: Don't navigate automatically - let TenantConfigurator handle the flow
                // The population modal might need to be shown first
                if (onRefresh) {
                    // Small delay to ensure data is saved before refreshing
                    setTimeout(() => {
                        onRefresh()
                        // REMOVED: Auto-navigation to admin dashboard
                        // Let the TenantConfigurator handle navigation after population setup
                    }, 500) // Reduced delay since we're not navigating
                }
            } else if (declined) {
                // For decline, call callback to close modal before logout
                callback(false)
            }
        } catch (e) {
            response = e
            // On error, call callback to close modal
            callback(false)
        } finally {
            setIsSubmitting(false)
        }

        return response
    }

    const declineAcknowledgement = async () => {
        if (isSubmitting) return // Prevent multiple submissions

        let response
        try {
            // Save the acknowledgment decline first
            response = await mutateAcknowledgement(true)

            // Then logout and redirect
            Auth.signOut()
                .then(() => {
                    StorageService.clearData()
                    window.location.href = '/' // Force redirect to login page
                })
                .catch((err) => {
                    console.error('Error during logout:', err)
                    // Force redirect even if logout fails
                    StorageService.clearData()
                    window.location.href = '/'
                })
        } catch (e) {
            console.error('Error during decline acknowledgement:', e)
            // Even if there's an error saving the decline, force logout for security
            Auth.signOut()
                .then(() => {
                    StorageService.clearData()
                    window.location.href = '/'
                })
                .catch(() => {
                    StorageService.clearData()
                    window.location.href = '/'
                })
        }
    }

    return (
        <div>
            <p>Acknowledgement of Receipt</p>

            <p>By clicking on the accept button I agree that:</p>

            <p>
                1. I am acknowledging receipt of the BSS Online Emergency Training Programs provided
                by building management to help enhance the safety of building occupants.
            </p>

            <p>
                2. I will disseminate this information, The Occupant Life Safety Training Program,
                to my company employees so they can take this training.
            </p>
            <div style={styles.buttonContainer}>
                <Button
                    type="danger"
                    onClick={() => declineAcknowledgement()}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                >
                    Decline
                </Button>
                <Button
                    type="primary"
                    onClick={() => mutateAcknowledgement(false)}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                >
                    Accept
                </Button>
            </div>
        </div>
    )
}

export default AcknowledgeForm
